export default __webpack_public_path__ + "static/media/grafema_amcc_01.b387691b.mp4";